<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication.html" xml:lang="en-US">
<div class="story">
<p class="pl-center"><span class="roman">For the Quayistas Mark 2—<br/>Linda, Jenny, Janet and the Significant Others.<br/>You know why.</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?40bc3df8